<template>
  <v-card>
    <v-card-title>
      <p class="pl-6">{{ $t("common.pef_list") }}</p>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('common.search')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      @click:row="handleClick"
      :headers="headers"
      :items="users"
      :loading="loading"
      item-key="id"
      class="elevation-1 row-pointer"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :options.sync="options"
      :server-items-length="-1"
      :items-per-page="-1"
      dense
    >
      <template v-slot:no-data>
        {{ $t("common.no_results") }}
      </template>
      <template #item.squad="{ item }">
        <span v-if="item.squad">
          {{ item.squad.name }}
        </span>
        <span v-else>N/A</span>
      </template>
      <template #item.action="{}">
        <v-icon small color=" darken-2"> mdi-arrow-right </v-icon></template
      >
    </v-data-table>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"

const { mapActions } = createNamespacedHelpers("user")

export default {
  name: "PefTable",
  mixins: [TableMixin],
  data() {
    return {
      items: [],
      params: { role: "PEF", archived: false },
    }
  },

  computed: {
    users() {
      return this.data
    },
    current_user() {
      return this.$store.state.user.profile
    },

    headers() {
      return [
        {
          value: "first_name",
          text: this.$tc("user.first_name", 1),
          width: "24%",
        },
        {
          value: "last_name",
          text: this.$tc("user.last_name", 1),
          width: "24%",
        },
        {
          value: "squad",
          text: this.$tc("user.squad", 1),
          width: "24%",
        },
        {
          value: "year",
          text: this.$tc("user.year", 1),
          width: "24%",
        },
        {
          value: "action",
        },
      ]
    },
  },

  methods: {
    ...mapActions([FETCH]),
    handleClick(pef) {
      this.$router.push({ name: "users", params: { user_id: pef.id } })
    },
  },
}
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
